// frontend/modules/document-type/types/document-type.types.ts

// Re-export orval-generated types
export type { 
  DocumentTypeDTO as DocumentType,
  CreateDocumentTypeDTO as CreateDocumentTypeRequest,
  UpdateDocumentTypeDTO as UpdateDocumentTypeRequest
} from '@/shared/api/model';

// Form data interface that matches CreateDocumentTypeDTO
export interface DocumentTypeFormData {
    code: string;
    name: string;
    description?: string;
    minUploadSizeKb?: number;
    maxUploadSizeKb?: number;
    allowedFileTypes?: string[];
    isActive: boolean;
    isRequired: boolean;
    displayOrder?: number;
}

export interface DocumentTypeFiltersData {
    search?: string;
    activeOnly?: boolean;
    requiredOnly?: boolean;
}

export interface FileValidationResult {
    valid: boolean;
    fileName: string;
    fileSizeBytes: number;
    documentTypeCode: string;
    errors?: string[];
}

export interface DocumentTypeStats {
    total: number;
    active: number;
    required: number;
    withSizeConstraints: number;
}

export const COMMON_FILE_TYPES = [
    'pdf', 'doc', 'docx', 'txt', 'rtf',
    'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp',
    'xls', 'xlsx', 'csv',
    'ppt', 'pptx',
    'zip', 'rar', '7z',
    'mp4', 'avi', 'mov', 'wmv',
    'mp3', 'wav', 'flac'
];

export const FILE_TYPE_CATEGORIES = {
    'Documents': ['pdf', 'doc', 'docx', 'txt', 'rtf'],
    'Images': ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
    'Spreadsheets': ['xls', 'xlsx', 'csv'],
    'Presentations': ['ppt', 'pptx'],
    'Archives': ['zip', 'rar', '7z'],
    'Videos': ['mp4', 'avi', 'mov', 'wmv'],
    'Audio': ['mp3', 'wav', 'flac']
};
